export const setStoragePeriod = (name, index) => {
  localStorage.setItem(name, JSON.stringify(index));
};

export const getStoragePeriod = (name) => {
  return JSON.parse(localStorage.getItem(name));
};
